// Pages/Bookings/Form.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Form from "../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import {
    create_booking,
    get_booking,
    update_booking,
} from "../../../../Controllers/Sales/Bookings";
import { get_quote } from "../../../../Controllers/Sales/Quotes";
import forms from "../../../../Data/Forms/Sales/Bookings/forms";
import headers from "../../../../Data/Forms/Sales/Bookings/headers";
import Loadercomponent from "../../../../Componets/Loader";
import Bodycomponent from "../../../../Componets/Formcomponents/body";
import Titlecomponent from "../../../../Componets/Formcomponents/title";
import Formdata from "../../../../Componets/Formcomponents/formdata";
import Headercomponent from "../../../../Componets/Formcomponents/header";
import Bookingtable from "../../../../Data/Forms/Sales/Bookings/table";
import { Input, Select, DatePicker } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import dayjs from "dayjs";


const BookingsForm = () => {
    let { id } = useParams();
    let navigate = useNavigate();
    let location = useLocation();

    // check if coming from a quote
    const queryParams = new URLSearchParams(location.search);
    const quote_id = queryParams.get("quote");

    const [loader, setLoader] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(false);
    const [header, setHeader] = useState(headers);
    const [values, setValues] = useState(forms);
    const [deposits, setDeposits] = useState([
        { amount: 0, type: "Cash", date: new Date() }
    ]);
    const [total_deposited, setTotalDeposited] = useState(0);

    const [details, setDetails] = useState([
        {
            id: "",
            description: null,
            name: "",
            unit: "",
            unit_name: "",
            quantity: "",
            sale_price: "",
            stock: "",
            booked_stock: "",
            tax: 0,
            tax_amount: "0.000",
            total: 0,
            discount_price: "",
            discount_percentage: "",
            price_per_unit: "",
            unit_details_options: [],
        },
    ]);

    const [totals, setTotals] = useState({
        subtotal: "0.000",
        taxamount: "0.000",
        discount: 0,
        total: "0.000",
    });

    const [note, setNote] = useState("");

    const findFieldIndex = (fieldName) => {
        return values[0].options.findIndex((opt) => opt.name === fieldName);
    };

    const formdata = async (data) => {
        if (data?.status) {
            setButtonLoader(true);

            const payload = {
                ...data?.data,
                details,
                deposits: deposits.map(d => ({
                    ...d,
                    amount: parseFloat(d.amount) || 0
                })),
                total_deposited: deposits.reduce((sum, d) => sum + (parseFloat(d.amount) || 0), 0),
                subtotal: totals?.subtotal,
                taxamount: totals?.taxamount,
                discount: totals?.discount,
                total: totals?.total,
                note,
                quote: quote_id || null,
            };

            const result = id
                ? await update_booking({ ...payload, id })
                : await create_booking(payload);

            if (result?.status) {
                toast?.success(result?.message);
                setButtonLoader(false);

                if (id) {
                    // After updating, go to view
                    navigate(`/app/sales/bookings/view/${id}`);
                } else {
                    // After creating, go to view the new booking
                    navigate(`/app/sales/bookings/view/${result?.data?._id}`);
                    // OR navigate(-1) if your API doesn't return the new ID
                }
            }
        }
    };

    const recalcDeposited = (deps) => {
        const total = deps.reduce((sum, d) => sum + parseFloat(d.amount || 0), 0);
        setTotalDeposited(total);
    };

    const handleAddDeposit = () => {
        setDeposits((prev) => [
            ...prev,
            { amount: "", type: "Cash", reference: "", date: new Date(), note: "" }
        ]);
    };

    const handleRemoveDeposit = (index) => {
        const updated = deposits.filter((_, i) => i !== index);
        setDeposits(updated);
        recalcDeposited(updated);
    };

    const handleDepositChange = (index, field, value) => {
        const updated = [...deposits];
        updated[index][field] = value;
        setDeposits(updated);
        if (field === "amount") recalcDeposited(updated);
    };

    // populate form from existing booking (edit)
    const handleData = (booking) => {
        const updatedValues = [...values];

        const customerIndex = findFieldIndex("Customer");
        const numberIndex = findFieldIndex("Number");
        const dateIndex = findFieldIndex("Date");
        const expiryIndex = findFieldIndex("Valid Until");
        const salesmanIndex = findFieldIndex("Salesman");
        const statusIndex = findFieldIndex("Status");
        if (booking?.deposits?.length > 0) {
            setDeposits(booking.deposits.map((d) => ({
                amount: d.amount || "",
                type: d.type || "Cash",
                reference: d.reference || "",
                date: d.date || new Date(),
                note: d.note || "",
            })));
            setTotalDeposited(booking.total_deposited || 0);
        }

        if (customerIndex !== -1) {
            updatedValues[0].options[customerIndex].form.value = booking?.customer?._id;
            updatedValues[0].options[customerIndex].form.options = booking?.customer?._id
                ? [{ value: booking?.customer?._id, label: booking?.customer?.name }]
                : null;
        }
        if (numberIndex !== -1) updatedValues[0].options[numberIndex].form.value = booking?.number;
        if (dateIndex !== -1) updatedValues[0].options[dateIndex].form.value = booking?.date;
        if (expiryIndex !== -1) updatedValues[0].options[expiryIndex].form.value = booking?.expiry_date;
        if (salesmanIndex !== -1) {
            updatedValues[0].options[salesmanIndex].form.value = booking?.salesman?._id;
            updatedValues[0].options[salesmanIndex].form.options = booking?.salesman?._id
                ? [{ value: booking?.salesman?._id, label: booking?.salesman?.name }]
                : null;
        }
        if (statusIndex !== -1) updatedValues[0].options[statusIndex].form.value = booking?.status;

        // map details
        let data = [];
        if (booking?.details?.length > 0) {
            booking?.details?.forEach((value) => {
                data.push({
                    id: value?._id,
                    description: value?.description?._id,
                    name: value?.name,
                    unit: value?.unit,
                    unit_name: value?.unit_name,
                    quantity: value?.quantity,
                    sale_price: value?.sale_price,
                    stock: value?.description?.stock,
                    booked_stock: value?.description?.booked_stock,
                    tax: value?.tax?.name ? value?.tax?.name : null,
                    tax_details: value?.tax,
                    tax_amount: value?.tax_amount,
                    total: value?.total,
                    discount_price: value?.discount_price,
                    discount_percentage: value?.discount_percentage,
                    price_per_unit: value?.price_per_unit,
                    unit_details_options: [],
                    options: [
                        {
                            value: value?.description?._id,
                            label: value?.description?.product?.name,
                        },
                    ],
                });
            });
        }

        setNote(booking?.note || "");
        setValues(updatedValues);
        setDetails(data);
        setTotals({
            subtotal: booking?.subtotal || "0.000",
            taxamount: booking?.taxamount || "0.000",
            discount: booking?.discount || 0,
            total: booking?.total || "0.000",
        });
        setLoader(false);
    };

    // populate form from quote (convert flow)
    const handleQuoteData = (quote) => {
        const updatedValues = [...values];

        const customerIndex = findFieldIndex("Customer");
        const dateIndex = findFieldIndex("Date");

        if (customerIndex !== -1) {
            updatedValues[0].options[customerIndex].form.value = quote?.customer?._id;
            updatedValues[0].options[customerIndex].form.options = quote?.customer?._id
                ? [{ value: quote?.customer?._id, label: quote?.customer?.name }]
                : null;
        }
        if (dateIndex !== -1) {
            updatedValues[0].options[dateIndex].form.value = new Date();
        }

        // map quote details → booking details
        let data = [];
        if (quote?.details?.length > 0) {
            quote?.details?.forEach((value) => {
                data.push({
                    id: "",
                    description: value?.description?._id || value?.description,
                    name: value?.name,
                    unit: value?.unit,
                    unit_name: value?.unit_name,
                    quantity: value?.quantity,
                    sale_price: value?.sale_price,
                    stock: value?.stock,
                    booked_stock: 0,
                    tax: value?.tax?.name ? value?.tax?.name : null,
                    tax_details: value?.tax,
                    tax_amount: value?.tax_amount,
                    total: value?.total,
                    discount_price: value?.discount_price,
                    discount_percentage: value?.discount_percentage,
                    price_per_unit: value?.price_per_unit,
                    unit_details_options: [],
                    options: [
                        {
                            value: value?.description?._id || value?.description,
                            label: value?.name,
                        },
                    ],
                });
            });
        }

        setValues(updatedValues);
        setDetails(data);
        setTotals({
            subtotal: quote?.subtotal || "0.000",
            taxamount: quote?.taxamount || "0.000",
            discount: quote?.discount || 0,
            total: quote?.total || "0.000",
        });
        setLoader(false);
    };

    const fetchData = async () => {
        if (id) {
            // edit existing booking
            setLoader(true);
            const result = await get_booking({ id });
            if (result?.status) {
                handleData(result?.data);
            } else {
                toast?.error(result?.message);
                setLoader(false);
            }
        } else if (quote_id) {
            // convert from quote
            setLoader(true);
            const result = await get_quote({ id: quote_id });
            if (result?.status) {
                handleQuoteData(result?.data);
            } else {
                toast?.error(result?.message);
                setLoader(false);
            }
        } else {
            // new booking
            const dateIndex = findFieldIndex("Date");
            if (dateIndex !== -1) {
                values[0].options[dateIndex].form.value = new Date();
            }
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <Header headers={header} setHeaders={setHeader} formdata={formdata}>
            <Loadercomponent loader={loader}>
                <Form
                    form={values}
                    setForm={setValues}
                    formdata={formdata}
                    buttonLoader={buttonLoader}
                >
                    <Bodycomponent>
                        <Titlecomponent index={1} title={"Items"} />
                        <Formdata>
                            <Headercomponent index={0} name={"Details"} required={true} />
                            <Bookingtable
                                details={details}
                                setDetails={setDetails}
                                totals={totals}
                                setTotals={setTotals}
                                note={note}
                                setNote={setNote}
                            />
                        </Formdata>
                    </Bodycomponent>
                    <Bodycomponent>
                        <Titlecomponent index={2} title={"Deposits"} />
                        <Formdata>
                            <div className="p-4">

                                {deposits.map((deposit, index) => (
                                    <div key={index} className="flex gap-3 items-end mb-3 flex-wrap">
                                        <div>
                                            <div className="text-xs text-gray-500 mb-1">Amount (OMR)</div>
                                            <Input
                                                type="number"
                                                className="w-[130px]"
                                                placeholder="0.000"
                                                value={deposit.amount}
                                                onChange={(e) =>
                                                    handleDepositChange(index, "amount", e.target.value)
                                                }
                                                autoComplete="off"
                                            />
                                        </div>
                                        <div>
                                            <div className="text-xs text-gray-500 mb-1">Type</div>
                                            <Select
                                                className="w-[140px]"
                                                placeholder="Type"
                                                value={deposit.type || undefined}
                                                options={[
                                                    { value: "Cash", label: "Cash" },
                                                    { value: "Bank Transfer", label: "Bank Transfer" },
                                                    { value: "Cheque", label: "Cheque" },
                                                    { value: "Card", label: "Card" },
                                                ]}
                                                onChange={(e) => handleDepositChange(index, "type", e)}
                                            />
                                        </div>
                                        <div>
                                            <div className="text-xs text-gray-500 mb-1">Reference</div>
                                            <Input
                                                className="w-[130px]"
                                                placeholder="Cheque / Ref No"
                                                value={deposit.reference}
                                                onChange={(e) =>
                                                    handleDepositChange(index, "reference", e.target.value)
                                                }
                                                autoComplete="off"
                                            />
                                        </div>
                                        <div>
                                            <div className="text-xs text-gray-500 mb-1">Date</div>
                                            <DatePicker
                                                className="w-[130px]"
                                                format="DD/MM/YYYY"
                                                value={deposit.date ? dayjs(deposit.date) : null}
                                                onChange={(e) =>
                                                    handleDepositChange(index, "date", e?.$d || null)
                                                }
                                            />
                                        </div>
                                        <div>
                                            <div className="text-xs text-gray-500 mb-1">Note</div>
                                            <Input
                                                className="w-[180px]"
                                                placeholder="Optional note"
                                                value={deposit.note}
                                                onChange={(e) =>
                                                    handleDepositChange(index, "note", e.target.value)
                                                }
                                                autoComplete="off"
                                            />
                                        </div>
                                        <div>
                                            {deposits.length > 1 && (
                                                <button
                                                    type="button"
                                                    className="text-red-500 hover:text-red-700"
                                                    onClick={() => handleRemoveDeposit(index)}
                                                >
                                                    <DeleteOutlined />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                ))}

                                <button
                                    type="button"
                                    className="text-xs px-3 py-1 mt-1 border border-green-500 text-green-600 rounded hover:bg-green-50"
                                    onClick={handleAddDeposit}
                                >
                                    + Add Deposit
                                </button>

                                <div className="flex gap-8 justify-end mt-4 pt-4 border-t">
                                    <div className="text-sm">
                                        <span className="text-gray-500">Total Deposited:&nbsp;</span>
                                        <span className="font-semibold text-green-600">
                                            OMR {parseFloat(total_deposited || 0).toFixed(3)}
                                        </span>
                                    </div>
                                    <div className="text-sm">
                                        <span className="text-gray-500">Remaining:&nbsp;</span>
                                        <span className="font-semibold text-orange-600">
                                            OMR {Math.max(
                                                0,
                                                parseFloat(totals?.total || 0) - parseFloat(total_deposited || 0)
                                            ).toFixed(3)}
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </Formdata>
                    </Bodycomponent>
                </Form>
            </Loadercomponent>
        </Header>
    );
};

export default BookingsForm;